// extracted by mini-css-extract-plugin
export default {"pricesContainer":"qiNDrcem0avw0vM23Oto","oldPrice":"zW2YGYFXx_MaZ4ECUt0m","priceBox":"BYnIkThHthibNQSd_XAo","description":"X9sO2vDkZnyLxN1DWdp2"};